/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DailyStorageSummary } from '../models/DailyStorageSummary';

export class DailyStorageSummaries {
  /**
  * List of daily storage summaries.
  */
  'data': Array<DailyStorageSummary>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "data",
      "baseName": "data",
      "type": "Array<DailyStorageSummary>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DailyStorageSummaries.attributeTypeMap;
  }

  public constructor() {
  }
}

